import { registerVueWindowVar } from 'src/js/global';
import 'src/utils/pollyfill.js';
import { createApp } from 'vue';
import App from './App.vue';
import { setupStore } from 'src/store';
import { setupRouter } from 'src/router';
// import { registerGlobComp } from 'src/components/registerGlobComp';
import GlobalConfig from 'src/config';
import Cookies from 'js-cookie';

// import RequestServiceTwo from 'src/js/requestTwo.js';
// import RequestService from 'src/js/request.js';
import * as dateFrom from 'src/js/dateFrom.js';

import { ExtendApp } from 'src/types/interface';

import 'virtual:windi.css';

import ElementResizeDetectorMaker from 'element-resize-detector';

// 引入 echarts 核心模块 和 常用组件, 如果需要其他组件请自行添加。
import echarts from 'src/plugins/echarts';

import qs from 'qs';

// import commonApi from 'src/js/common.js';

import XEUtils from 'xe-utils';

import { useTable } from './plugins/vxe-table';

import 'src/styles/theme/main.less';
import directives from 'src/js/directives.js';

import md5 from 'js-md5';
import { useElement } from 'src/plugins/element-plus';
import { useAxios } from 'src/plugins/axios';

import moment from 'moment';

import 'vant/lib/index.css';
import { Popup } from 'vant';
import { Step, Steps } from 'vant';

moment.suppressDeprecationWarnings = true;
// 添加全局变量
const extendApp = function (app) {
    // app.config.globalProperties.$Cookies = Cookies;
    registerVueWindowVar(app, '$Cookies', Cookies);

    // app.config.globalProperties.$GlobalConfig = GlobalConfig;
    registerVueWindowVar(app, '$GlobalConfig', GlobalConfig);

    // app.config.globalProperties.$RequestServiceTwo = RequestServiceTwo;
    // registerVueWindowVar(app, '$RequestServiceTwo', RequestServiceTwo);

    // app.config.globalProperties.$RequestService = RequestService;
    // registerVueWindowVar(app, '$RequestService', RequestService);

    // app.config.globalProperties.$dateFrom = dateFrom;
    registerVueWindowVar(app, '$dateFrom', dateFrom);

    // app.config.globalProperties.$erd = ElementResizeDetectorMaker();
    registerVueWindowVar(app, '$erd', ElementResizeDetectorMaker());

    // app.config.globalProperties.$echarts = echarts;
    registerVueWindowVar(app, '$echarts', echarts);

    // app.config.globalProperties.$qs = qs;
    registerVueWindowVar(app, '$qs', qs);

    // app.config.globalProperties.$commonApi = commonApi;
    // registerVueWindowVar(app, '$commonApi', commonApi);

    // app.config.globalProperties.$utils = XEUtils;
    registerVueWindowVar(app, '$utils', XEUtils);

    // app.config.globalProperties.$md5 = md5;
    registerVueWindowVar(app, '$md5', md5);

    useAxios(app);

    useTable(app);

    useElement(app);
    app.use(directives);
    app.use(Popup);
    // app.use(BackTop);
    app.use(Step);
    app.use(Steps);
};

async function bootstrap() {
    const app = createApp(App);

    // 扩展vue
    extendApp(app as ExtendApp<Element>);
    //
    // 配置store
    setupStore(app as ExtendApp<Element>);
    //
    // 注册全局组件
    // registerGlobComp(app as ExtendApp<Element>);
    //
    // 配置路由
    setupRouter(app as ExtendApp<Element>);

    app.mount('#app');
}

bootstrap();
